module.exports = __webpack_public_path__ + "img/elevator.4b6900a8.svg";